module.exports = __webpack_public_path__ + "img/footer_logo5.b85ad2c6.jpg";